import React from 'react'
import { graphql } from 'gatsby'
import { useIntl } from 'gatsby-plugin-intl'

import Layout from 'components/layout'
import Hero from 'components/home/Hero'
import Suites from 'components/home/Suites'
import MetaTags from 'components/MetaTags'
import Neighbourhood from 'components/home/Neighbourhood'
import Experience from 'components/home/Experience'

import {
  homePageByLocale,
  homeApartmentCardsForLocale,
} from 'content/homePage'

const Home = ({ data }) => {
  const intl = useIntl()
  const home = homePageByLocale[intl.locale]
  const apartments = homeApartmentCardsForLocale(intl.locale)

  const {
    headerImage: {
      childImageSharp: { fluid },
    },
  } = data

  return (
    <Layout>
      <MetaTags
        title='Hotel Griffintown'
        description={home.metaDescription}
      />
      <Hero
        fluid={fluid}
        heading={home.hero.heading}
        description={home.hero.description}
      />
      <Suites
        eyebrow={home.suites.eyebrow}
        heading={home.suites.heading}
        subheading={home.suites.subheading}
        apartments={apartments}
      />
      <Neighbourhood
        eyebrow={home.neighbourhood.eyebrow}
        heading={home.neighbourhood.heading}
        description={home.neighbourhood.description}
      />
      <Experience
        eyebrow={home.experience.eyebrow}
        heading={home.experience.heading}
        description={home.experience.description}
      />
    </Layout>
  )
}

export const query = graphql`
  query Home {
    headerImage: file(name: { eq: "img-hero-home" }) {
      childImageSharp {
        fluid(maxWidth: 2560, quality: 100, cropFocus: CENTER) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default Home
